import eventList from './event_list/eventList';
import error from './error';
import auth from './auth/auth';
import navbar from './navbar/navbar';
import correspondances from './miscellaneous/correspondances';
import generic from './miscellaneous/generic';
import timeFormat from './miscellaneous/timeFormat';
import table from './miscellaneous/table';
import washelpful from './miscellaneous/washelpful';
import questioncard from './miscellaneous/questioncard';
import aiQuestionCard from './miscellaneous/aiQuestionCard';
import dashboard from './dashboard/dashboard';
import dashboardWidgets from './dashboard/dashboardWidgets';
import profile from './profile/profile';
import eventFeedback from './event_feedback/eventFeedback';
import caregiverList from './caregiver_list';
import caregiverDetail from './caregiver_detail';
import form from './form';

export default {
  eventList,
  error,
  auth,
  navbar,
  correspondances,
  generic,
  timeFormat,
  table,
  washelpful,
  questioncard,
  aiQuestionCard,
  dashboard,
  dashboardWidgets,
  profile,
  eventFeedback,
  caregiverList,
  caregiverDetail,
  ...form,
};
